import { Component, Injector, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'mission-legal-entity',
    templateUrl: './mission-legal-entity.component.html',
    styleUrls: ['./mission-legal-entity.component.scss'],
    standalone: false
})
export class MissionLegalEntityComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  options: FormControlOption[] = [
    {
      label: 'Pack SCI',
      value: 'PACK_ESSENTIEL_SCI',
      displayValue:
        '<span class="description"> <span class="displayValue">600€ </span>TTC par an',
      displayValueAsHtml: true,
      suffix: 'D',
      formControlName: 'packEssentielOption',
      input: {
        formControlName: 'packEssentielSci',
      },
      description:
        'Collecte, saisie et production des liasses fiscales. Accompagnement pour le report de votre résultat d’activité de loueur meublée sur votre déclaration de revenus personnelle.',
    },
    {
      label: 'Pack SCI à l’IR',
      value: 'PACK_ESSENTIEL_SCI_IR',
      displayValue:
        '<span class="description"> <span class="displayValue">180€ </span>TTC par an',
      displayValueAsHtml: true,
      suffix: 'D',
      formControlName: 'packEssentielSciIROption',
      input: {
        formControlName: 'packEssentielSciIr',
      },
      description:
        'Accompagnement pour le report de votre résultat d’activité de loueur sur votre déclaration de revenus personnelle.',
    },
    {
      label: 'Pack essentiel SARL de Famille',
      value: 'PACK_SARL',
      displayValue:
        '<span class="description"> <span class="displayValue">600€ </span>TTC par an',
      displayValueAsHtml: true,
      suffix: 'D',
      formControlName: 'packSarlOption',
      input: {
        formControlName: 'packSarl',
      },
      description:
        'Accompagnement pour le report de votre résultat d’activité de loueur sur votre déclaration de revenus personnelle.',
    },
    {
      label: 'Budget prévisionnel',
      value: '300€ TTC',
      displayValue: '€ TTC',
      hardFormControlName: 'provisionalBudget',
      suffix: 'A',
      formControlName: 'provisionalBudgetOption',
      description: 'Accompagnement pour budgéter un projet.',
    },
    {
      label: 'Mission sociale',
      value: 'Social mission',
      suffix: 'C',
      formControlName: 'socialMissionOption',
      input: {
        formControlName: 'socialMission',
      },
      description:
        'Pour les clients assujettis, formalités d’affiliation et déclarations périodiques.',
    },
  ];
  isConsultant = false;
  optionInfo: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  contractActive: boolean;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
    private sanitizer: DomSanitizer,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.isConsultant = !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    const productName = pledge?.products?.[0]?.productName;
    if (productName?.includes('SARL')) {
      this.options = this.options.filter(
        option =>
          option.value != 'PACK_ESSENTIEL_SCI' &&
          option.value != 'PACK_ESSENTIEL_SCI_IR',
      );
    }
    if (productName?.includes('SCI')) {
      this.options = this.options.filter(option => option.value != 'PACK_SARL');
    }
    if (!this.isConsultant) {
      this.options = this.options.filter(
        option => option.value != 'Social mission',
      );
    }

    this.subscriptionFacade.initForm(this);
    this.contractActive =
      this.subscriptionFacade.getPledge()?.products?.[0]?.parameters?.isContractActive;
    if (this.contractActive && this.isConsultant) {
      this.options.forEach(option => (option.displayValue = false));
    }
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
  select(option: FormControlOption) {
    const checked = this.products
      .get('0')
      .get('parameters')
      .get(option.formControlName)?.value;
    if (!checked) {
      this.products
        .get('0')
        .get('parameters')
        .get(option.formControlName)
        ?.setValue(true);
    }
  }
  getDisplayValueAsHtml(option: FormControlOption): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(option.displayValue || '');
  }
}
